// components
import useStableSearchParams from '@/hooks/useStableSearchParams';

export const LIVE_RANGE_OPTIONS = [60, 30, 10, 5] as const;

export type LiveRangeMinutes = (typeof LIVE_RANGE_OPTIONS)[number];

const LIVE_RANGE_PARAM = 'liveRange';
const DEFAULT_LIVE_RANGE_MINUTES: LiveRangeMinutes = 30;

function isLiveRangeMinutes(value: number): value is LiveRangeMinutes {
  return LIVE_RANGE_OPTIONS.includes(value as LiveRangeMinutes);
}

function parseLiveRangeMinutes(value: string | null): LiveRangeMinutes {
  if (!value) {
    return DEFAULT_LIVE_RANGE_MINUTES;
  }

  const parsedValue = Number(value);

  if (!Number.isInteger(parsedValue) || !isLiveRangeMinutes(parsedValue)) {
    return DEFAULT_LIVE_RANGE_MINUTES;
  }

  return parsedValue;
}

function useLiveModeRange(): [
  LiveRangeMinutes,
  (minutes: LiveRangeMinutes) => void,
] {
  const [searchParams, setSearchParams] = useStableSearchParams();
  const liveRangeMinutes = parseLiveRangeMinutes(
    searchParams.get(LIVE_RANGE_PARAM),
  );

  const setLiveRangeMinutesInUrl = (minutes: LiveRangeMinutes) => {
    setSearchParams((prev: URLSearchParams) => {
      const nextParams = new URLSearchParams(prev);
      nextParams.set(LIVE_RANGE_PARAM, String(minutes));
      return nextParams;
    });
  };

  return [liveRangeMinutes, setLiveRangeMinutesInUrl];
}

export default useLiveModeRange;
